import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth0: () => import("/app/middleware/auth0.ts"),
  "feature-flags-hooks": () => import("/app/middleware/feature-flags-hooks.ts")
}